@layer refine.base {
  :host {
    display: block;
  }

  nav {
    display: block;
  }

  ol {
    display: flex;
    flex-wrap: wrap;
    gap: 0;
    align-items: center;
    padding: 0;
    margin: 0;
    list-style: none;
  }
}
